<template>
  <div>
    <div v-if="!nalaganje">
      <div class="rating-grid">
        <leaderboard-card v-if="ratingDeviation > 87.5" showInfo="true" :progress="(1-ratingDeviation/350)*100" />
        <rating-quiz-button :gid="gid" sid="root" :yid="yid" />
        <leaderboard :gid="gid" />
        <rating-history-card :gid="gid" :uid="uid" />
      </div>
      <div class="info-container">
        <!-- Current Rating -->
        <info-card :title="$t('pages.ratingHistory.currentRating')" icon="glyphicon glyphicon-stats" iconColor="#0073b7" :value="rating"/>
        <!-- Rating Accuracy -->
        <info-card v-if="ratingDeviation <= 70" :title="$t('pages.exams.ratingResults.ratingAccuracy')" icon="fa fa-bullseye" iconColor="#0073b7" :value="Math.round((1 - ratingDeviation/350) * 100) + '%'"/>
        <info-card v-else-if="ratingDeviation <= 180" :title="$t('pages.exams.ratingResults.ratingAccuracy')" icon="fa fa-bullseye" iconColor="#f39c12" :value="Math.round((1 - ratingDeviation/350) * 100) + '%'"/>
        <info-card v-else :title="$t('pages.exams.ratingResults.ratingAccuracy')" icon="fa fa-bullseye" iconColor="#dd4b39" :value="Math.round((1 - ratingDeviation/350) * 100) + '%'"/>
        <!-- Solved Exercises -->
        <info-card v-if="solvedExercises/allExercises < 1" title="Resene naloge" icon="fa fa-list" iconColor="#0073b7" :value="solvedExercises + '/' + allExercises"/>
        <info-card v-else title="Resene naloge" icon="fa fa-list" iconColor="#00a65a" :value="solvedExercises + '/' + allExercises"/>
      </div>
      <!------------------------------------------------------->
      <graph v-if="ratingHistory.length>0" :ratingHistory="ratingHistory"/>
      <histogram v-if="histogram" :histogram="histogram" :rating="rating"/>
    </div>
  </div>
</template>

<script>
  import Rest from '../../services/rest'
  import {mapGetters} from 'vuex'
  import InfoCard from '@/components/rating/cards/InfoCard.vue'
  import LeaderboardCard from '@/components/rating/cards/LeaderboardAccuracyCard.vue'
  import RatingQuizButton from '@/components/rating/cards/RatingQuizButton.vue'
  import Leaderboard from '@/components/rating/cards/Leaderboard.vue'
  import RatingHistoryCard from '@/components/rating/cards/RatingHistoryCard.vue'
  import Graph from '@/components/rating/cards/Graph.vue'
  import Histogram from '@/components/rating/cards/Histogram.vue'

  export default {
    name: 'UserRating',
    props: ['gid', 'yid', 'uid'],
    computed: {
      dataById () {
        return this.$route.name === 'UserRatingById' || this.$route.name === 'UserRatingByIdAdmin'
      },
      filteredSubgroups () {
        return this.subgroupArray.filter((subgroup) => {
          if (subgroup.expanded) {
            return true
          }
          // Display subgroups with parent set to null
          if (subgroup.parent === null) {
            return true
          }
          // Hide all other subgroups
          return false
        })
      },
      ...mapGetters({
        seznamPodskupin: 'getSubgroups',
        dnevneNaloge: 'getDailyChallenges',
        seznamKvizov: 'getExams',
        jeAdmin: 'hasAdminRole'
      })
    },
    components: {
      Histogram,
      Graph,
      RatingHistoryCard,
      Leaderboard,
      RatingQuizButton,
      LeaderboardCard,
      InfoCard
    },
    data () {
      return {
        nalaganje: true,
        rating: 1000,
        ratingDeviation: 350,
        bestRating: 1000,
        worstRating: 1000,

        ratingHistory: [],
        loadingSubgroups: false,
        histogram: null,

        currentUser: null,
        leaderboard: [],
        toggleLeaderboard: true,

        allExercises: 0,
        solvedExercises: 0
      }
    },
    mounted () {
      this.$store.dispatch('getGroup', {
        gid: this.gid,
        yid: this.yid,
        sid: 'root'
      })
      this.$store.commit('updateAdminBreadcrumbs', [{path: '', name: {'en-us': 'Rating', sl: 'Rating'}}])
      this.pridobiPodatke()
    },
    methods: {
      pridobiPodatke () {
        let postdata = {
          groupId: this.gid
        }
        if (this.dataById) {
          postdata['userId'] = this.uid
        }
        return Rest.request('POST', `/rating/userRatingStatistics`, postdata).then((data) => {
          this.ratingHistory = data.history
          this.histogram = data.ratingHistogramUsers
          if (this.ratingHistory.length > 0) {
            this.bestRating = this.ratingHistory[0].newRating
            this.worstRating = this.ratingHistory[0].newRating
          }
          for (let i = 1; i < this.ratingHistory.length; i++) {
            if (this.bestRating < this.ratingHistory[i].newRating) {
              this.bestRating = this.ratingHistory[i].newRating
            }
            if (this.worstRating > this.ratingHistory[i].newRating) {
              this.worstRating = this.ratingHistory[i].newRating
            }
          }
          if (this.ratingHistory.length !== 0) {
            this.rating = this.ratingHistory[this.ratingHistory.length - 1].newRating
            this.ratingDeviation = this.ratingHistory[this.ratingHistory.length - 1].newRatingDeviation
          }
          this.showLeaderboard()
        }).catch((err) => {
          this.nalaganje = false
          console.log(err)
        })
      },
      showLeaderboard () {
        Rest.request('GET', '/rating/leaderboard/' + this.gid).then((data) => {
          this.leaderboard = data.userRatings
          this.currentUser = this.$store.getters.getUser
          let index = this.leaderboard.map(function (e) {
            return e.username
          }).indexOf(this.currentUser.username)

          if (index === -1) {
            this.toggleLeaderboard = false
          } else if (index > 5) {
            this.leaderboard[5] = this.leaderboard[index]
            this.leaderboard[5].place = index
          }
          this.getNumberOfSolvedExercises()
          this.nalaganje = false
        })
      },
      getNumberOfSolvedExercises () {
        Rest.request(`GET`, `/rating/getSolvedExercises/` + this.currentUser.id + '/' + this.gid).then((data) => {
          this.allExercises = data.allExercises
          this.solvedExercises = data.solvedExercises
        })
      }
    }
  }
</script>

<style scoped>
.info-container {
  margin: 30px 0;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 30px;
}
.rating-grid {
  display: grid;
  grid-template-columns: 60% 40%;
  gap: 30px;
}
@media (max-width: 480px) {
  .rating-grid{
    grid-template-columns: 100%;
  }
  .info-container {
    grid-template-columns: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// UserRating.vue?9cea23b4